import React from 'react';
import searchResource from '../../../locales/th/search.json';
import { ClearButtonWrapper } from './DesktopFilter.style';

interface Props {
  /**
   * Call when the button is clicked
   */
  onCancel: () => void;
  /**
   * If true, the button is not clickable.
   */
  isDisabled?: boolean;
}

const ClearButton = ({ onCancel, isDisabled }: Props): React.ReactElement => {
  const onClick = () => {
    if (!isDisabled) {
      onCancel();
    }
  };

  return (
    <ClearButtonWrapper
      isDisabled={isDisabled}
      role={isDisabled ? 'none' : 'button'}
      onClick={onClick}
    >
      {searchResource.searchFilter.clearFilter}
    </ClearButtonWrapper>
  );
};

export default ClearButton;
